import { DepositFiatPaymentMethod, WithdrawFiatPaymentMethod } from 'config/types/payment'
import useFullSizeModalRouteUpdater from 'hooks/useFullSizeModalRouteUpdater'
import { RowMiddle } from 'layout/Components/Row'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
import { ModalBody, ModalHeader } from 'UIKit/AlchemyModal'
import { ModalProps, ModalSizeModeEnum } from 'UIKit/AlchemyModal/Modal'
import { ListBankSelect } from 'views/Payment/DesktopPayment/components/BankSelectDropdown'
import { PAYMENT_MODAL_THEME, PaymentAppSearch, StylePaymentModal } from '../../components/styles'

export type FiatPaymentMethodModalProps<T = WithdrawFiatPaymentMethod | DepositFiatPaymentMethod> = {
  methods: [string, T[]][]
  onSelectMethod: (selectedItem: T) => void
  selectedMethod?: T
}

const FiatPaymentMethodModal: React.FC = ({
  data: { methods, onSelectMethod, selectedMethod },
  onDismiss,
}: ModalProps<FiatPaymentMethodModalProps<DepositFiatPaymentMethod | WithdrawFiatPaymentMethod>>) => {
  const [searchOnlineBanking, setSearchingOnlineBanking] = useState('')
  const onBack = useFullSizeModalRouteUpdater(`DF-select-method-${selectedMethod?.name}`, onDismiss)
  const { t } = useTranslation()

  return (
    <StyledAlchemyModal sizeMode={ModalSizeModeEnum.Full} colorTheme={PAYMENT_MODAL_THEME} onDismiss={onBack}>
      <ModalHeader
        colorTheme={PAYMENT_MODAL_THEME}
        useBackIcon
        onBack={onBack}
        hideClose
        hideStroke
        title={
          <RowMiddle width="100%" pl="32px">
            <PaymentAppSearch
              width="100%"
              placeholder={t('Local Bank Transfer (LBT)')}
              value={searchOnlineBanking}
              onValueChanged={setSearchingOnlineBanking}
            />
          </RowMiddle>
        }
      />

      <ModalBody>
        <ListBankSelect
          onSelect={(method) => {
            onSelectMethod(method)
            onBack()
          }}
          banks={methods}
          typedSearchBank={searchOnlineBanking}
          selectedMethod={selectedMethod}
          maxHeight="100%"
        />
      </ModalBody>
    </StyledAlchemyModal>
  )
}

const StyledAlchemyModal = styled(StylePaymentModal)`
  .wrap-header-container {
    padding-block: 8px;

    .wrap-action-header {
      height: 100%;
      max-height: 100%;
      width: fit-content;
    }
  }
`

export default FiatPaymentMethodModal
